import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { CommonModule } from '@angular/common';

// hybridify
import { UpgradeModule } from '@angular/upgrade/static';
import { UIRouterUpgradeModule } from "@uirouter/angular-hybrid";


// legacy screens
import '@legacy/Index';
import '@legacy/AppConstant';
import '@legacy/version';
import '@legacy/Entities/Notification';
import '@legacy/Entities/Login';
import '@legacy/Entities/logout';
import '@legacy/Entities/AdditionalFields';
import '@legacy/Entities/AuditLog';
import '@legacy/Entities/BankAccount';
import '@legacy/Entities/Company';
import '@legacy/Entities/ConfigurationGroup';
import '@legacy/Entities/Customer';
import '@legacy/Entities/CustomerDataArea';
import '@legacy/Entities/StrappingChartProfiles';
import '@legacy/Entities/DataArea';
import '@legacy/Entities/DeviceProduct';
import '@legacy/Entities/DeviceProductGroup';
import '@legacy/Entities/Driver';
import '@legacy/Entities/ExportTransPacConfiguration';
import '@legacy/Entities/Fleet';
import '@legacy/Entities/Factor';
import '@legacy/Entities/ImportTransPacConfiguration';
import '@legacy/Entities/LoadPoint';
import '@legacy/Entities/PaymentTerm';
import '@legacy/Entities/PriceGroup';
import '@legacy/Entities/Product';
import '@legacy/Entities/ProductGroup';
import '@legacy/Entities/PriceGroup';
import '@legacy/Entities/SafetyCheckText';
import '@legacy/Entities/SalesTax';
import '@legacy/Entities/TimeLog';
import '@legacy/Entities/TransPacConfiguration';
import '@legacy/Entities/User';
import '@legacy/Entities/Vehicle';


// legacy directives
import '@legacy/Scripts/Directives/datetimepicker-directive';
import '@legacy/Scripts/Directives/input-number';
import { HttpClientModule } from '@angular/common/http';
import { DxDataGridModule, DxTooltipModule, DxToastModule, DxLoadPanelModule, DxPopupModule, DxDropDownBoxModule,DxButtonModule } from 'devextreme-angular';
import { ProductsModule } from '@products/products.module';
import { FleetModule } from './fleet/fleet.module';
import { SettingsModule } from './settings/settings.module';
import { LoginComponent } from './login/login.component';
import { SharedModule } from './_shared/shared.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LoginSSOComponent } from './login-sso/login-sso.component';
import { LoadPointComponent } from './load-point/load-point.component';
import { NgxSmartModalModule,NgxSmartModalService } from 'ngx-smart-modal';
import { CustomersModule } from './customers/customers.module';
import { SafetyCheckComponent } from './safety-check/safety-check.component';
import { PdiInputModule } from '@pdi/platform-angular-template';
import { PdiButtonsModule } from '@pdi/platform-angular-template';
import { PdiFooterModule } from "@pdi/platform-angular-template";
import { PdiNotificationsModule } from '@pdi/platform-angular-template';


@NgModule({
    declarations: [
    LoginComponent,
    FooterComponent,
    HeaderComponent,
    LoginSSOComponent,
    LoadPointComponent,
    SafetyCheckComponent
  ],
    
    imports: [
        BrowserModule,
        UpgradeModule,
        UIRouterUpgradeModule.forRoot(),
        HttpClientModule,
        FleetModule,
        ProductsModule,
        SettingsModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        CommonModule,
        DxDataGridModule,
        DxTooltipModule,
        DxLoadPanelModule,
        DxToastModule,
        DxPopupModule,
        DxDropDownBoxModule,
        DxButtonModule,
        NgxSmartModalModule.forRoot(),
        CustomersModule,
        PdiInputModule,
        PdiButtonsModule,
        PdiFooterModule,
        PdiNotificationsModule

    ],
    providers: [NgxSmartModalService],
    bootstrap: [] // hybrid starts ng1 below
})
export class AppModule {
    constructor(private upgrade: UpgradeModule) { }
    ngDoBootstrap() {
        this.upgrade.bootstrap(document.getElementById('FleetAtlasApp'), ['FleetAtlasApp'], { strictDi: false });
    }
}
